import { request } from "services/api/util";

class ShiseidoProductCategoryService {
  async getShiseidoProductCategory() {
    const config = {
      method: "get",
      url: `admin/shiseidoProductCategories`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
  async setShiseidoProductCategory(body) {
    let config;
    config = {
      method: "put",
      url: `admin/shiseidoProductCategories`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ShiseidoProductCategoryService();
